<div class="max-w-lg mx-auto mt-10 bg-white shadow-lg rounded-2xl p-6">
  <h2 class="text-2xl font-bold mb-4 text-center">Vendor Registration</h2>


  <form (ngSubmit)="submit()" class="space-y-4">
    <div>
      <label class="block text-sm font-medium">Email</label>
      <input type="email" [(ngModel)]="model.email" name="email"
             class="w-full border rounded-xl px-3 py-2 mt-1 focus:ring-2 focus:ring-indigo-500" required />
    </div>


    <div>
      <label class="block text-sm font-medium">Password</label>
      <input type="password" [(ngModel)]="model.password" name="password"
             class="w-full border rounded-xl px-3 py-2 mt-1 focus:ring-2 focus:ring-indigo-500" required />
    </div>


    <div>
      <label class="block text-sm font-medium">Store Name</label>
      <input [(ngModel)]="model.storeName" name="storeName"
             class="w-full border rounded-xl px-3 py-2 mt-1" required />
    </div>


    <div>
      <label class="block text-sm font-medium">Store Description</label>
<textarea [(ngModel)]="model.storeDescription" name="storeDescription"
          class="w-full border rounded-xl px-3 py-2 mt-1" required></textarea>
      <!--<p *ngIf="model.storeDescription.invalid && model.storeDescription.touched" class="text-red-500 text-sm mt-1">
        Store description is required.
      </p>-->
    </div>


    <div>
      <label class="block text-sm font-medium">Contact Phone</label>
      <input [(ngModel)]="model.contactPhone" name="contactPhone"
             class="w-full border rounded-xl px-3 py-2 mt-1" required />
    </div>


    <button type="submit" [disabled]="loading"
            class="w-full bg-indigo-600 text-white rounded-xl py-2 font-semibold hover:bg-indigo-700">
      Register
    </button>
  </form>


  <p *ngIf="message" class="text-green-500 mt-2 text-center">{{ message }}</p>
  <p *ngIf="error" class="text-red-500 mt-2 text-center">{{ error }}</p>

</div>
